import {Equals, ValidateNested} from "class-validator";
import {UserWithPassword} from "../user/user.model";
import {UserProfile} from "./userProfile.model";

class SignUpProfile extends UserProfile {
    @ValidateNested()
    userWithPassword: UserWithPassword;

    @Equals(true, { message: "" })
    termsAndConditions: boolean;

    allowMarketing: boolean;

    reCaptchaToken: string;
}

export { SignUpProfile }
